import BaseService from "./baseService";
import { reloadPublicLinks } from "../redux/actions/index";

export class PublicLinkService extends BaseService {
  constructor(base) {
    super(base);
    this.url = "/public-link";
    this.name = "Publiclinks";
  }
  getPublicChannel(id) {
    const url = "/public-link/get-channel";
    let data = { id: id, timezone: new Date().getTimezoneOffset() };
    return this.post(url, JSON.stringify(data));
  }
  reload() {
    let self = this;
    return this.read().then(function(data) {
      if (!data.hasOwnProperty("error")) {
        self.store.dispatch(reloadPublicLinks(data));
      }
    });
  }
  patch(url, body) {
    return fetch(`${this.BASE_URL}` +url, {
      method: "PATCH",
      withCredentials: true,
      body: body,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("id-tkn")
      }
    }).then(resp => resp);
  }
}

export default PublicLinkService;
